import { Injectable } from '@angular/core';

import { HttpClientHelper } from '../helpers/HttpClientHelper';
import { IJobCategory } from '../models/advert.model';
import { HttpParameter } from '../datatypes/misc';
import { Observable } from 'rxjs';

@Injectable()
export class JobService {

    constructor(private httpClientHelper: HttpClientHelper) {}

    getJobCategories(): Observable<IJobCategory[]> {
        return this.httpClientHelper.httpGet(new HttpParameter('Job.Categories'));
    }
}
